import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-site-logo',
  templateUrl: './site-logo.component.html',
  styleUrls: ['./site-logo.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class SiteLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
